import moment from 'moment';

export function addTimeToNameFile(nameFile, extension) {
    const uploadTime = moment(new Date()).format('DD-MM-YYYY HH:mm:ss');
    const fileNameWithoutExtension = nameFile.substr(0, nameFile.length - extension.length - 1);
    return `${fileNameWithoutExtension} ${uploadTime}.${extension}`.replace(/\s|:/g, '_');
}
